import { createAction } from '@reduxjs/toolkit';

import { InitWalletsPayload } from './types';

export const initWallets = createAction<InitWalletsPayload>(
  'finance/wallets/init'
);
